import {
  DocumentData,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { appFireStore, timestamp } from "../../firebase";

export const useUser = () => {
  const collectionRef = collection(appFireStore, "user");

  const getCloudUser = async (uid: string) => {
    const q = query(collectionRef, where("uid", "==", uid), limit(1));

    let result: any[] = [];
    const user = await getDocs(q).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        result.push({ ...doc.data() });
      });
    });

    return result[0];
  };

  const setCloudUser = async (uid: string, username: string) => {
    const createdTime = timestamp.fromDate(new Date());
    const cloudUser = await getCloudUser(uid);
    if (!cloudUser) {
      setDoc(doc(collectionRef, uid), {
        uid: uid,
        username: username,
        level: 1,
        requestLevelUp: false,
        scrapAlbum: [],
        scrapUser: [],
        createdTime,
      });
    }
  };

  // const userAlbumAdd = async (uid: string) => {
  //   await setDoc(
  //     doc(collectionRef, uid),
  //     {
  //       userVocalList: userVocalList,
  //     },
  //     { merge: true }
  //   );
  // };

  return { getCloudUser, setCloudUser };
};
